import { ReactNode, useState } from 'react'
import { Container } from './styles'
import { Menu } from '../Menu'
import { useWindowSize } from 'react-use'
import Header from '../Header'

interface IProps {
  children: ReactNode
}

const Layout = (props: IProps) => {
  const { height } = useWindowSize()
  const [headerHeight, setHeaderHeight] = useState(null)

  const [isMenuOpen, setIsMenuOpen] = useState(window.innerWidth >= 1000)

  const closeMenu = () => setIsMenuOpen(false)

  return (
    <Container style={{ height, overflow: 'hidden' }}>
      <Header onRoutesDropdownClick={closeMenu} setHeaderHeight={setHeaderHeight} />

      <div style={{ display: 'flex', height: height - headerHeight }}>
        <Menu isOpen={isMenuOpen} onToggle={() => setIsMenuOpen((state) => !state)} />

        <main
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            flexGrow: 1,
            position: 'relative',
          }}
          id="layout--scrollable-area"
        >
          {props.children}
        </main>
      </div>
    </Container>
  )
}

export default Layout
